import AccountRouterComponent from './AccountRouterComponent/index';


const AccountRouter = AccountRouterComponent;

export default AccountRouter;